/**
 * Howler wrapper — preload + play 3 SFX Phase 1 (Phụ lục E whitelist).
 *
 * Mute state persist `localStorage`. Sound chỉ chạy sau user gesture
 * đầu tiên (browser autoplay policy) — gọi `unlock()` trong onClick handler
 * đầu tiên.
 *
 * Tham chiếu: `docs/analysis/02_use_cases.md` UC-10 + design doc §6.6.
 */
import { Howl, Howler } from "howler";

type SoundKey = "ingredient_click" | "serve_success" | "revenue_ting";

const SOUND_FILES: Record<SoundKey, string> = {
  ingredient_click: "/assets/sounds/ingredient_click.mp3",
  serve_success: "/assets/sounds/serve_success.mp3",
  revenue_ting: "/assets/sounds/revenue_ting.mp3",
};

const MUTED_STORAGE_KEY = "cafechuquan_muted";

const sounds: Partial<Record<SoundKey, Howl>> = {};
let unlocked = false;

/**
 * Preload tất cả SFX critical. Gọi 1 lần khi app mount.
 */
export function preloadSounds(): void {
  for (const [key, src] of Object.entries(SOUND_FILES) as Array<[SoundKey, string]>) {
    if (sounds[key]) continue;
    sounds[key] = new Howl({
      src: [src],
      volume: 0.5,
      preload: true,
      html5: false,
    });
  }
  // Apply mute state đã lưu.
  Howler.mute(isMuted());
}

/** Unlock audio context sau user gesture đầu tiên. */
export function unlock(): void {
  unlocked = true;
}

/** Play 1 SFX — no-op nếu chưa unlock. */
export function playSound(key: SoundKey): void {
  if (!unlocked) return;
  const s = sounds[key];
  if (!s) return;
  s.play();
}

export function setMuted(muted: boolean): void {
  Howler.mute(muted);
  try {
    localStorage.setItem(MUTED_STORAGE_KEY, muted ? "true" : "false");
  } catch {
    // SSR / private mode — ignore.
  }
}

export function isMuted(): boolean {
  try {
    return localStorage.getItem(MUTED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function toggleMuted(): boolean {
  const next = !isMuted();
  setMuted(next);
  return next;
}
